// extracted by mini-css-extract-plugin
export default {"unfollowButton":"styles---unfollowButton---zmfFk","pendingButton":"styles---pendingButton---eybKo","largeButton":"styles---largeButton---EoJVP"};